import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AuthNewStoreSeller() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/auth/new-store", { replace: true });
  }, [navigate]);

  return null;
}
